import { Field as BaseField } from '@tabeo/scarf'
import PropTypes from 'prop-types'
import React from 'react'
import { Field as FinalField } from 'react-final-form'

export const composeValidators =
  (...validators) =>
  (value, values) =>
    validators.reduce(
      (error, validator) => error || validator(value, values),
      undefined
    )

const Field = React.forwardRef(
  (
    {
      validate,
      name,
      // https://github.com/final-form/react-final-form/issues/130
      parse = v => v,
      format,
      ScarfField = BaseField,
      onChange,
      ...rest
    },
    ref
  ) => {
    let validator = validate
    if (Array.isArray(validate)) {
      validator = composeValidators(...validate)
    }

    return (
      <FinalField
        validate={validator}
        name={name}
        parse={parse}
        format={format}
        {...rest}
      >
        {({ meta, input }) => {
          const extendedInput = {
            ...input,
            // Allows external onChange handlers to be invoked whenever the field changes,
            // in addition to the built-in final-form onChange.
            onChange: (...args) => {
              input.onChange?.(...args)
              onChange?.(...args)
            },
          }
          return (
            <ScarfField ref={ref} {...rest} meta={meta} input={extendedInput} />
          )
        }}
      </FinalField>
    )
  }
)

Field.propTypes = {
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  name: PropTypes.string.isRequired,
  parse: PropTypes.func,
  format: PropTypes.func,
  ScarfField: PropTypes.elementType,
  onChange: PropTypes.func,
}

export default Field
